/*
 * @Author: song 
 * @Date: 2018-02-05 14:03:12 
 * @Last Modified by: song
 * @Last Modified time: 2018-02-11 10:03:22
 */
export default {
  name: "common",
  login: {
    work_login_04: {
      toLoginHref:'./login.html',
      toPersonalCenterHref:'',
    }
  },
  common: {
    vote_03: {
      url: '../data/work_common_03_data.json'
    }
  }
};


// WEBPACK FOOTER //
// ./src/projects/huayu/config/dev/common.js